'use strict';

var helper = require('../helper');

function mapTopUpSteps (step) {
    const mapping = {
        'step1': 'step1-add_card_number_field',
        'step2': 'step2-add_pin_card',
        'step3': 'step3-add_credit_confirmation'
    };
    return mapping[step] || 'unknown_step';
}

function mapTopUpStepsSuccess (step, success) {
    success = success ? 'success' : 'error';
    return mapTopUpSteps(step) + '_' + success;
}

function mapExitFlowActions (action) {
    const mapping = {
        1: 'close_the_flow',
        2: 'leave_flow',
        3: 'no_cancel'
    };
    return mapping[action] || 'unknown_action';
}

function mapTopUpFromCheckBalanceButton (action) {
    const mapping = {
        'upload': 'add_the_balance_to_the_digital_wallet',
        'uploaded': 'uploaded_credit_to_wallet-popup',
        'close': 'close-popup'
    };
    return mapping[action] || 'unknown_action';
}

module.exports = {
    // 6.61 FRONT-END ERROR
    pushTopUpError (step, errorCode) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '62',
            'eventname': 'frontend_error',
            'type': 'credit_top_up_to_wallet',
            'step': mapTopUpSteps(step),
            'text': errorCode
        };
        helper.log('Pushing front-end error interaction', true);
        helper.push(pushObject);
    },
    // 7.166  Credit top-up
    pushCreditTopUp () {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '190',
            'eventname': 'my_wallet',
            'action': 'top_up_balance'
        };
        helper.log('Pushing credit top up interaction', true);
        helper.push(pushObject);
    },
    // 7.168, 7.169, 7.170  Credit top-up
    pushGiftcardTopUp (step, cardModel, success) {
        const eventId = step === 'step1' ? '192' : (step === 'step2' ? '193' : '194');
        cardModel = cardModel ? cardModel.toLowerCase() : null;
        cardModel = cardModel === 'gift' ? 'giftcard' : (cardModel === 'reso' ? 'return_card' : 'not_available');

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': eventId,
            'eventname': 'my_wallet_credit_top_up',
            'step': mapTopUpStepsSuccess(step, success),
            'type': cardModel
        };
        helper.log('Pushing giftcard/returncard top up interaction', true);
        helper.push(pushObject);
    },
    // 7.171  top-up flow exit
    pushExitTopUpFlow (step, action, success) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '195',
            'eventname': 'my_wallet_credit_top_up',
            'action': mapExitFlowActions(action),
            'step': mapTopUpStepsSuccess(step, success)
        };
        helper.log('Pushing top up exit interaction', true);
        helper.push(pushObject);
    },
    // 7.165 top-up from giftcard check balance
    pushGiftcardTopUpFromCheckBalance (action) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '189',
            'eventname': 'gift_card',
            'action': mapTopUpFromCheckBalanceButton(action)
        };
        helper.log('Pushing giftcard top up from check balance page interaction', true);
        helper.push(pushObject);
    },
    // 7.164 removing digital wallet as payment method
    pushRemoveDigitalWallet () {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '188',
            'eventname': 'my_wallet',
            'action': 'remove_tezenis_wallet_as_payment_method'
        };
        helper.log('Pushing remove digital wallet as payment method interaction', true);
        helper.push(pushObject);
    }
};
